<div class="header">
  <div *ngIf="canClose" (click)="onClick()" class="header-back clickable">
    <mat-icon>chevron_left</mat-icon>
  </div>
  <div class="header-title-wrapper vcenter">
    <div class="header-title vcenter">{{ header }} </div>
    <ng-container *ngIf="subtitle">
      <div class="text-small">{{ subtitle }}</div>
    </ng-container>
  </div>
</div>